import { FC, Ref } from "react";
import { Segmented as AntSegmented, SegmentedProps as AntSegmentedProps } from "antd";
import { clsx } from "clsx";
import classes from "./Segmented.module.less";

export interface SegmentedProps extends Omit<AntSegmentedProps, "ref"> {
    ref?: Ref<HTMLDivElement>;
}

export const Segmented: FC<SegmentedProps> = ({ className, ...props }) => {
    return <AntSegmented {...props} className={clsx(classes.segmented, className)} />;
};

Segmented.displayName = "Segmented";
